import { ThemeProvider } from "@prismicio/editor-ui"
import type { PropsWithChildren } from "react"

import { useLabDarkMode } from "../../../lab/useLabSettings"

export function AppThemeProvider(props: PropsWithChildren) {
  const labDarkMode = useLabDarkMode()

  return (
    <ThemeProvider mode={labDarkMode ? "dark" : "light"}>
      {props.children}
    </ThemeProvider>
  )
}
